"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../../../../atoms/Icon";

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const HOST_CLASS = "schedulerMobileDrawerHost";

function getPortalRoot(): HTMLElement | null {
  return document.querySelector<HTMLElement>(".conversationWrapper");
}

const SchedulerMobileDrawer = ({ open, onClose, children }: Props) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalRoot(getPortalRoot());
  }, []);

  useEffect(() => {
    if (!open || !portalRoot) return;
    portalRoot.classList.add(HOST_CLASS);
    return () => portalRoot.classList.remove(HOST_CLASS);
  }, [open, portalRoot]);

  if (!portalRoot) return null;

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="schedulerMobileDrawer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <button
            type="button"
            className="schedulerMobileDrawer__backdrop"
            onClick={onClose}
            aria-label="Close scheduler"
          />
          <motion.div
            className="schedulerMobileDrawer__sheet"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
            role="dialog"
            aria-modal="true"
            aria-label="Schedule a time"
          >
            <button
              type="button"
              className="schedulerMobileDrawer__close"
              onClick={onClose}
              aria-label="Close"
            >
              <Icon name="close" className="!size-5 shrink-0 fill-current" />
            </button>
            <div className="schedulerMobileDrawer__content">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    portalRoot
  );
};

export default SchedulerMobileDrawer;
